import React from 'react';
import Container from '../components/Container';
import TableTitle from '../components/TableTitle';
import { PermissionsContent } from '../features/permissions';

const Permissions = () => {
  return (
    <Container>
      <TableTitle containerClass={'max-w-7xl mx-auto'} title={'Настройка ролей'} />
      <PermissionsContent />
    </Container>
  );
};
export default Permissions;
